import { createEditorPlugins } from 'articleEditor/utils/createEditorPlugins';
import { PLATE_ID } from 'lib-knowledge-document-structure';
import { Plate } from 'lib-knowledge-document-structure/plate/common';
import { MyEditor, MyValue } from 'lib-knowledge-document-structure/plateTypes';
import { ReactNode, useContext, useMemo, useRef } from 'react';
import { snapshot } from 'valtio';

import { ArticleSavingContext } from './savingContext';

type PlateProviderProps = {
  children: ReactNode;
};

/** Article content has loaded, so display the editor */
export const PlateProvider = ({
  children,
}: PlateProviderProps): JSX.Element => {
  const editorRef = useRef<MyEditor>(null);
  const { savingStore, actions } = useContext(ArticleSavingContext);

  const plugins = useMemo(
    () => createEditorPlugins({ debouncedSave: actions.debouncedSave }),
    [actions],
  );

  // Remove the proxy, because now Plate uses it's own Proxy
  const body = snapshot(savingStore.currentArticleDetails.body);

  return (
    <Plate<MyValue, MyEditor>
      normalizeInitialValue
      editorRef={editorRef}
      id={PLATE_ID}
      // @ts-expect-error Seems to be a type mismatch with createPlugins
      plugins={plugins}
      onChange={actions.setBody}
      // NOTE: value here is INITIAL VALUE, changing value will NOT re-render
      // see https://docs.slatejs.org/walkthroughs/01-installing-slate
      value={body as MyValue}
      readOnly={savingStore.editorReadonly}
    >
      {children}
    </Plate>
  );
};
